import DUANWEI_DATA from './duanwei.json'
const localMap = {
  'en': '英文',
  'vi': '越南语',
  'id': '印尼语',
  'th': '泰语',
  'hk': '繁中',
  'tw': '繁中',
  'sg': '英文',
  'my': '英文',
  'ph': '英文',
}
export const getHighestRankInfo = (data, locale) => {
  // maxRankScore 枪战对决
  // maxBrRankScore 吃鸡
  // maxSavageRankScore 野人
  const { maxRankScore, maxSavageRankScore, maxBrRankScore } = data
  const keys = ['qiangzhanduijue', 'chiji', 'yeren']
  let key = ''
  let score = 0
  if (maxRankScore >= maxSavageRankScore && maxRankScore >= maxBrRankScore) {
    score = maxRankScore
    key = keys[0]
  } else if (maxSavageRankScore >= maxRankScore && maxSavageRankScore >= maxBrRankScore) {
    score = maxSavageRankScore
    key = keys[1]
  } else {
    score = maxBrRankScore
    key = keys[2]
  }
  const duanweiData = DUANWEI_DATA[key]
  if (!duanweiData) {
    return {
      key,
      score,
      name: '--'
    }
  }
  let duanwei = {}
  duanweiData.forEach(item => {
    if (score >= item['段位所需积分']) {
      duanwei = item
    }
  })
  if (!duanwei) {
    return {
      key,
      score,
      name: '--'
    }
  }
  const name = duanwei[localMap[locale]] || '--'
  return {
    key,
    score,
    name
  }
}
